import { categoriesAdapter } from "../adapters/categories-adapter";
import { CategoriesResource } from "../resources/categories-resource";
import { ClientCategories } from "../types/categories";

export const CategoriesRepository = {
  async fetchCategories(): Promise<ClientCategories> {
    const options = await CategoriesResource.getCategories();
    return categoriesAdapter.toClientCategories(options);
  },
};
